import { TResponsiveType } from '@features/responsive/typescript';

const getCurrentDevice = (currentBreakpoint: TResponsiveType | undefined) => {
  if (!currentBreakpoint) {
    return 'desktop';
  }

  switch (currentBreakpoint) {
    case 'mobile':
      return 'mobile';

    case 'mobilelg':
      return 'mobile';

    case 'tablet':
      return 'tablet';

    case 'tabletlg':
      return 'tablet';

    default:
      return 'desktop';
  }
};

export default getCurrentDevice;
